import { api } from '@shared/api';
import {
  Candle,
  Candles,
  ChartBarsParams,
  ChartBarsQuery,
  LatestBarQuery,
  ResolveChartSymbolData,
} from '@shared/api/@types/charts';

import { AxiosResponse } from 'axios';
import { SwyftxPlatform } from 'src/lib/utils/utils.types';

const resolveSymbol = async (primary: string, secondary: string, platform: SwyftxPlatform) => {
  let res: AxiosResponse<ResolveChartSymbolData>;

  if (platform === 'derivatives') {
    res = await api.endpoints.nextGenResolveChartSymbol({
      params: { primary, secondary },
      platform: 'derivatives',
    });
  } else {
    res = await api.endpoints.resolveChartSymbol({
      params: { primary, secondary },
    });
  }

  return res;
};

const getChartBars = async (params: ChartBarsParams, query: ChartBarsQuery, platform: SwyftxPlatform) => {
  let res: AxiosResponse<Candles>;

  if (!query.resolution) {
    query.resolution = '1d';
  }

  if (platform === 'derivatives') {
    res = await api.endpoints.getNextGenChartBars({ params, query, platform: 'derivatives' });
  } else {
    query.isPro = platform === 'swyftx-pro';
    res = await api.endpoints.getChartBars({ params, query });
  }

  return res;
};

const getChartLatestBar = async (params: ChartBarsParams, query: LatestBarQuery, platform: SwyftxPlatform) => {
  let res: Candle;

  if (!query.resolution) {
    query.resolution = '1d';
  }

  if (platform === 'derivatives') {
    res = (await api.endpoints.getNextGenChartLatestBar({ params, query, platform: 'derivatives' })).data.candle;
  } else {
    query.isPro = platform === 'swyftx-pro';
    res = (await api.endpoints.getChartLatestBar({ params, query })).data;
  }

  return res;
};

export { resolveSymbol, getChartBars, getChartLatestBar };
